import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { CalendarCheck, Car, Star, Phone } from "lucide-react";
import { heroImages, brand, stats } from "../mock";
import { Button } from "./ui/button";

export default function Hero() {
  const [idx, setIdx] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % heroImages.length), 6000);
    return () => clearInterval(t);
  }, []);

  const goto = (hash) => {
    const el = document.querySelector(hash);
    el && el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section className="relative min-h-[92vh] flex items-center pt-24 pb-16 overflow-hidden">
      {/* Background slideshow */}
      <div className="absolute inset-0">
        {heroImages.map((src, i) => (
          <div key={i} className={`absolute inset-0 transition-opacity duration-1000 ${i === idx ? "opacity-100" : "opacity-0"}`}>
            <img src={src} alt="" className="w-full h-full object-cover animate-kenburns" />
          </div>
        ))}
        <div className="absolute inset-0 bg-gradient-to-r from-black/85 via-black/60 to-black/25" />
      </div>

      {/* Content */}
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 w-full">
        <div className="max-w-2xl text-white animate-fade-up">
          <div className="flex items-center gap-3 mb-5">
            <span className="inline-block bg-[#e2001a] text-white text-xs font-semibold tracking-wide uppercase px-3 py-1 rounded-full">
              {brand.tagline}
            </span>
            <span className="inline-flex items-center gap-1 text-sm text-white/90">
              <Star className="w-4 h-4 fill-yellow-400 text-yellow-400" />
              <strong>{brand.rating.toString().replace(".", ",")}</strong>
              <span className="text-white/60">· {brand.reviewsCount} recensioni</span>
            </span>
          </div>

          <h1 className="font-display font-extrabold text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
            La tua officina di fiducia a Treviso
          </h1>
          <p className="mt-5 text-lg text-gray-200 max-w-lg">
            {brand.claim}. Revisioni, tagliandi, meccanica, gomme, elettrauto e diagnostica.
            Preventivi gratuiti e trasparenti.
          </p>

          <div className="mt-8 flex flex-wrap gap-3">
            <Button
              onClick={() => goto("#contatti")}
              className="h-12 px-6 rounded-full bg-[#e2001a] hover:bg-[#c00016] text-white font-semibold text-base"
            >
              <CalendarCheck className="w-5 h-5 mr-2" /> Prenota un servizio
            </Button>
            <Button
              onClick={() => navigate("/auto")}
              variant="outline"
              className="h-12 px-6 rounded-full bg-white/10 border-white/40 text-white hover:bg-white hover:text-[#16181d] font-semibold text-base backdrop-blur"
            >
              <Car className="w-5 h-5 mr-2" /> Auto in vendita
            </Button>
            <a
              href={brand.phoneHref}
              className="h-12 px-5 rounded-full inline-flex items-center gap-2 text-white font-semibold hover:text-[#ff8896] transition-colors"
            >
              <Phone className="w-5 h-5" /> {brand.phone}
            </a>
          </div>
        </div>

        {/* Stats */}
        <div className="mt-14 grid grid-cols-2 sm:grid-cols-4 gap-6 max-w-3xl animate-fade-up" style={{ animationDelay: "0.25s" }}>
          {stats.map((s) => (
            <div key={s.label}>
              <p className="font-display font-extrabold text-3xl text-white">{s.value}</p>
              <p className="text-sm text-gray-300">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
